import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = [
  {
    q: 'Как активировать ключ?',
    a: 'После оплаты перейдите в раздел «Заказы» — там будет ваш ключ. Активируйте его в официальном магазине платформы (PS Store, Xbox, Nintendo eShop).',
  },
  {
    q: 'Сколько времени занимает доставка?',
    a: 'Доставка мгновенная. Ключ появляется в вашем заказе сразу после подтверждения оплаты.',
  },
  {
    q: 'Что делать если ключ не работает?',
    a: 'Напишите нам в Telegram или на почту support@freeapp.ru. Мы разберёмся и заменим ключ или вернём деньги.',
  },
  {
    q: 'Можно ли вернуть деньги?',
    a: 'Да, если ключ оказался нерабочим — оформим возврат или замену. Активированные ключи возврату не подлежат.',
  },
  {
    q: 'Для каких регионов работают ключи?',
    a: 'На странице каждого товара указан регион активации. Перед покупкой убедитесь, что регион совпадает с вашим аккаунтом.',
  },
];

const FaqItem = ({ q, a }: { q: string; a: string }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="overflow-hidden rounded-[18px] border border-foreground/8 bg-foreground/[0.03]">
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
      >
        <span className="text-sm font-medium text-foreground">{q}</span>
        <ChevronDown className={`h-4 w-4 shrink-0 text-foreground/30 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="border-t border-foreground/[0.07] px-5 pb-4 pt-3">
          <p className="text-sm leading-6 text-foreground/55">{a}</p>
        </div>
      )}
    </div>
  );
};

const SupportPage = () => (
  <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
    <div className="mx-auto max-w-3xl">

      <div className="mb-8">
        <h1 className="text-3xl font-semibold sm:text-5xl">Центр помощи</h1>
        <p className="mt-3 text-foreground/40">Ответы на часто задаваемые вопросы</p>
      </div>

      <div className="space-y-2">
        {FAQ.map(item => <FaqItem key={item.q} {...item} />)}
      </div>

      <div className="mt-6 rounded-[24px] border border-foreground/10 bg-card p-6">
        <p className="font-semibold text-foreground">Не нашли ответ?</p>
        <p className="mt-1 text-sm text-foreground/40">Напишите нам — ответим быстро</p>
        <div className="mt-4 flex flex-wrap gap-3">
          <a
            href="https://t.me/freeapp"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-2xl bg-[linear-gradient(90deg,#991b1b,#dc2626)] px-5 py-2.5 text-sm font-medium text-white transition hover:opacity-90"
          >
            Написать в Telegram
          </a>
          <a
            href="mailto:support@freeapp.ru"
            className="inline-flex items-center gap-2 rounded-2xl border border-foreground/10 bg-foreground/5 px-5 py-2.5 text-sm font-medium text-foreground/60 transition hover:border-foreground/20 hover:text-foreground"
          >
            support@freeapp.ru
          </a>
        </div>
      </div>

    </div>
  </div>
);

export default SupportPage;
